exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".styles__container___2E_ai {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  height: 30px;\n  letter-spacing: 0.1px;\n  color: #3099ff;\n  border-radius: 3px;\n  border: 1px solid #3099ff;\n  cursor: pointer;\n  padding: 0 11px;\n}\n.styles__container___2E_ai .styles__input___2zylb {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  left: -9999px;\n}\n.styles__container___2E_ai:hover {\n  background-color: #3099ff;\n  color: #fff;\n}\n.styles__container___2E_ai.styles__disabled___yP-U3:hover,\n.styles__container___2E_ai.styles__disabled___yP-U3 {\n  background-color: #c0c7ce;\n  border-color: #c0c7ce;\n  color: #fff;\n  cursor: not-allowed;\n}\n", ""]);

// exports
exports.locals = {
	"container": "styles__container___2E_ai",
	"input": "styles__input___2zylb",
	"disabled": "styles__disabled___yP-U3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./node_modules/stylus-loader!./src/components/shared/UploadButton/styles.styl
// module id = 704
// module chunks = 0